import React, { useEffect, Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import WhatIDo from "@/components/sections/WhatIDo";
import Experience from "@/components/sections/Experience";
import CredibilityStrip from "@/components/sections/CredibilityStrip";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import { scrollRef } from "@/lib/scroll";
import { trackVisit } from "@/lib/visitor";
import VisitsAdmin from "@/components/VisitsAdmin";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-ink px-6 text-center">
          <div>
            <p className="font-mono text-xs tracking-[0.3em] text-fog">SOMETHING BROKE</p>
            <button
              data-testid="error-reload-button"
              onClick={() => window.location.reload()}
              className="mt-6 bg-white px-8 py-3 font-mono text-[11px] tracking-[0.2em] text-ink hover:bg-accent"
            >
              RELOAD
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const Home = () => {
  useEffect(() => {
    trackVisit();
  }, []);
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <WhatIDo />
        <Experience />
        <CredibilityStrip />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    scrollRef.lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      scrollRef.lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/visits" element={<VisitsAdmin />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Toaster position="bottom-right" theme="dark" />
      </BrowserRouter>
      <div aria-hidden className="grain" />
    </ErrorBoundary>
  );
}
